// extracted by mini-css-extract-plugin
export default {"graphWrapper":"styles_graph-wrapper__7f+LT","opportunityGraphs":"styles_opportunity-graphs__JgSnz"};